import React from 'react';

export const NoMatch: React.FC = ({ children }) => (
  <div className="text-left hover:text-gray-100 py-3 px-4 hover:bg-gray-20 first:rounded-t last:rounded-b body-small ring-inset ring-offset-2 hover:ring-offset-gray-20 ring-primary-60 text-gray-70">
    <div className="flex space-x-3 items-center w-full">
      <div>{children}</div>
    </div>
  </div>
);
